import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// import { v4 as uuidV4 } from 'uuid';
import { useSelector } from 'react-redux';

import { ListSelectUserPermissionsStyle } from './ListSelectUserPermissionsStyle';
import translate from '../../libs/i18n';

import Api from '../../libs/Api';

import SelectOptions from '../SelectOptions/SelectOptions';

import CheckIcon from '../../assets/svgs/CheckIcon';
import DeleteIcon from '../../assets/svgs/DeleteReportIcon';

const ListSelectUserPermissions = ({
  userPermissions,
  setUserPermissions,
  handleDeleteSelectPermission,
  selectId,
  hasUserDataForEdition,
  multi_field_text,
}) => {
  const language = useSelector((state) => state.settings.language);

  const [institutions, setInstitutions] = useState([]);
  const [institutionOptions, setInstitutionOptions] = useState([]);
  const [institutionIDSelected, setInstitutionIDSelected] = useState(0);
  const [addExams, setAddExams] = useState(false);
  const [seeExams, setSeeExams] = useState(false);
  const [approveReport, setApproveReport] = useState(false);
  const [previousInstitutionID, setPreviousInstitutionID] = useState(0);

  const [hasPreSelectedInstitution, setHasPreSelectedInstitution] =
    useState(false);

  useEffect(() => {
    Api.getInstitutionsAndPermissions().then((response) => {
      if (response?.data?.avaliable_to_doc_and_tec?.institutions?.length) {
        setInstitutions(response.data.avaliable_to_doc_and_tec.institutions);
      }
    });

    if (hasUserDataForEdition && selectId && selectId?.id) {
      setInstitutionIDSelected(selectId.id);
      setHasPreSelectedInstitution(true);
      if (selectId?.permissions?.length) {
        if (selectId?.permissions.includes('add_exams')) {
          setAddExams(true);
        }

        if (selectId?.permissions.includes('see_results')) {
          setSeeExams(true);
        }

        if (selectId?.permissions.includes('approve_report')) {
          setApproveReport(true);
        }
      }
    } else {
      setInstitutionIDSelected('');
    }
  }, [hasUserDataForEdition, selectId]);

  useEffect(() => {

    // multi_field_text = translate('searchInstitutions', language)

    const currentInstitutionOptions = [
      { key: 0, value: '', text: multi_field_text }
    ];

    if (
      hasPreSelectedInstitution &&
      institutionIDSelected !== previousInstitutionID
    ) {
      setHasPreSelectedInstitution(false);
    }

    if (institutions?.length) {
      const availableInstitutionsID = institutions.filter(
        (uI) => uI !== institutionIDSelected
      );

      institutions.forEach((institution) => {
        if (!availableInstitutionsID.includes(institution.id)) {
          currentInstitutionOptions.push({
            key: institution.id,
            value: institution.id,
            text: institution.name,
          });
        }
      });

      setInstitutionOptions(currentInstitutionOptions);
    }
  }, [
    hasPreSelectedInstitution,
    hasUserDataForEdition,
    institutionIDSelected,
    institutions,
    previousInstitutionID,
    selectId,
    userPermissions.length,
    multi_field_text
  ]);

  useEffect(() => {
    if (institutionIDSelected && (addExams || seeExams || approveReport)) {
      const currentUserPermissionsList = userPermissions;
      const existingInstitutionUserSelected = currentUserPermissionsList.find(
        (institution) => institution.id === institutionIDSelected
      );
      if (existingInstitutionUserSelected?.id) {
        if (
          addExams &&
          !existingInstitutionUserSelected?.permissions?.includes('add_exams')
        ) {
          existingInstitutionUserSelected.permissions.push('add_exams');
          setUserPermissions(currentUserPermissionsList);
        } else if (
          !addExams &&
          existingInstitutionUserSelected?.permissions?.includes('add_exams')
        ) {
          existingInstitutionUserSelected?.permissions?.splice(
            existingInstitutionUserSelected?.permissions?.indexOf('add_exams'),
            1
          );

          setUserPermissions(currentUserPermissionsList);
        }

        if (
          seeExams &&
          !existingInstitutionUserSelected?.permissions?.includes('see_results')
        ) {
          existingInstitutionUserSelected.permissions.push('see_results');
          setUserPermissions(currentUserPermissionsList);
        } else if (
          !seeExams &&
          existingInstitutionUserSelected?.permissions?.includes('see_results')
        ) {
          existingInstitutionUserSelected?.permissions?.splice(
            existingInstitutionUserSelected?.permissions?.indexOf(
              'see_results'
            ),
            1
          );

          setUserPermissions(currentUserPermissionsList);
        }

        if (
          approveReport &&
          !existingInstitutionUserSelected?.permissions?.includes(
            'approve_report'
          )
        ) {
          existingInstitutionUserSelected.permissions.push('approve_report');
          setUserPermissions(currentUserPermissionsList);
        } else if (
          !approveReport &&
          existingInstitutionUserSelected?.permissions?.includes(
            'approve_report'
          )
        ) {
          existingInstitutionUserSelected?.permissions?.splice(
            existingInstitutionUserSelected?.permissions?.indexOf(
              'approve_report'
            ),
            1
          );

          setUserPermissions(currentUserPermissionsList);
        }
      } else {
        const newUserPermission = {
          id: institutionIDSelected,
          permissions: [],
        };

        if (addExams) {
          newUserPermission?.permissions?.push('add_exams');
          currentUserPermissionsList.push(newUserPermission);
          setUserPermissions(currentUserPermissionsList);
        }

        if (seeExams) {
          newUserPermission?.permissions?.push('see_results');
          currentUserPermissionsList.push(newUserPermission);
          setUserPermissions(currentUserPermissionsList);
        }

        if (approveReport) {
          newUserPermission?.permissions?.push('approve_report');
          currentUserPermissionsList.push(newUserPermission);
          setUserPermissions(currentUserPermissionsList);
        }
      }
    } else if (
      institutionIDSelected &&
      !addExams &&
      !seeExams &&
      !approveReport
    ) {
      const currentUserPermissionsList = userPermissions;
      const existingInstitutionUserSelected = currentUserPermissionsList.find(
        (institution) => institution.id === institutionIDSelected
      );
      if (existingInstitutionUserSelected?.id) {
        const newUserPermissionsList = currentUserPermissionsList.filter(
          (permissionObject) => permissionObject.id !== institutionIDSelected
        );
        setUserPermissions(newUserPermissionsList);
      }
    }

    if (
      institutionIDSelected !== previousInstitutionID &&
      !hasPreSelectedInstitution
    ) {
      setAddExams(false);
      setSeeExams(false);
      setApproveReport(false);

      const newPermissionList = userPermissions.filter(
        (institutionPermission) =>
          institutionPermission.id !== previousInstitutionID
      );

      setUserPermissions(newPermissionList);
      setPreviousInstitutionID(institutionIDSelected);
    } else if (
      institutionIDSelected !== previousInstitutionID &&
      hasPreSelectedInstitution
    ) {
      return setPreviousInstitutionID(institutionIDSelected);
    }
    return false;
  }, [
    institutionIDSelected,
    addExams,
    seeExams,
    approveReport,
    setUserPermissions,
    previousInstitutionID,
    userPermissions,
    hasPreSelectedInstitution,
  ]);

  const handleChangeSelect = (value, options, setValue) => {
    const currentOption = options.find(
      (option) => `${option.value}` === `${value}`
    );

    if (currentOption) {
      setValue(currentOption.value);
    }
  };
  return (
    <ListSelectUserPermissionsStyle>
      <span className="input-label">Instituição *</span>

      <div className="input">
        <div className="select-element-wrapper">
          <SelectOptions
            theme="soft-blue-outline"
            id="role"
            options={institutionOptions}
            value={institutionIDSelected}
            onChange={(value) =>
              handleChangeSelect(
                value,
                institutionOptions,
                setInstitutionIDSelected
              )
            }
          />
        </div>
        <button
          className="delete-button"
          type="button"
          onClick={() =>
            handleDeleteSelectPermission(selectId, institutionIDSelected)
          }
        >
          <DeleteIcon />
        </button>
      </div>
      <h1 className="title-permissions">Permissions *</h1>
      <div className="permissions">
        <div className="option-container">
          <button
            type="button"
            className="check-box"
            onClick={
              institutionIDSelected ? () => setAddExams(!addExams) : null
            }
          >
            <span className="box">{addExams ? <CheckIcon /> : null}</span>
          </button>
          <span className="text-permission">Add Exams</span>
        </div>
        <div className="option-container">
          <button
            type="button"
            className="check-box"
            onClick={
              institutionIDSelected ? () => setSeeExams(!seeExams) : null
            }
          >
            <span className="box">{seeExams ? <CheckIcon /> : null}</span>
          </button>
          <span className="text-permission">See Exams</span>
        </div>
        <div className="option-container">
          <button
            type="button"
            className="check-box"
            onClick={
              institutionIDSelected
                ? () => setApproveReport(!approveReport)
                : null
            }
          >
            <span className="box">{approveReport ? <CheckIcon /> : null}</span>
          </button>
          <span className="text-permission">Approve Report</span>
        </div>
      </div>
    </ListSelectUserPermissionsStyle>
  );
};

ListSelectUserPermissions.propTypes = {
  userPermissions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      permission: PropTypes.string,
      institution: PropTypes.institution,
    })
  ),
  setUserPermissions: PropTypes.func.isRequired,
  handleDeleteSelectPermission: PropTypes.func.isRequired,
  selectId: PropTypes.string.isRequired,
  hasUserDataForEdition: PropTypes.bool,
  multi_field_text: PropTypes.string,
};

ListSelectUserPermissions.defaultProps = {
  userPermissions: [],
  hasUserDataForEdition: false,
};

export default ListSelectUserPermissions;
